import axios from "axios";
import { IGetAuthorizedListRequestData, IGetBlacklistRequestData, IGetEventsListRequestData } from "../../interfaces";
import { BASE_API_URL, getAPIHeaderOptions } from "../../utils/apiUtils";
import { downloadFile } from "../../utils/commonUtils";

const DOWNLOAD_RESPONSE_CONTENT_FILENAME_IDENTIFIER = "filename=";

const handleDownloadEventLogs = (requestData: IGetEventsListRequestData): Promise<void> => {
	return new Promise((resolve, reject) => {
		axios
			.get(`${BASE_API_URL}/analytics/download/logs`, {
				headers: getAPIHeaderOptions(true),
				responseType: "blob",
				params: requestData
			})
			.then((response) => {
				if (response.data) {
					const responseContent = String(response.headers["content-disposition"]);
					const fileName = responseContent.split(DOWNLOAD_RESPONSE_CONTENT_FILENAME_IDENTIFIER)[1] ?? "";

					downloadFile(new Blob([response.data]), fileName);
					resolve();
				} else {
					reject("Something went wrong");
				}
			})
			.catch((error) => reject(error?.response?.data?.detail));
	});
};

const handleDownloadBlacklist = (requestData: IGetBlacklistRequestData): Promise<void> => {
	return new Promise((resolve, reject) => {
		axios
			.get(`${BASE_API_URL}/analytics/blacklist_vehicles/download`, {
				headers: getAPIHeaderOptions(true),
				responseType: "blob",
				params: requestData
			})
			.then((response) => {
				if (response.data) {
					const responseContent = String(response.headers["content-disposition"]);
					const fileName = responseContent.split(DOWNLOAD_RESPONSE_CONTENT_FILENAME_IDENTIFIER)[1] ?? "";

					downloadFile(new Blob([response.data]), fileName);
					resolve();
				} else {
					reject("Something went wrong");
				}
			})
			.catch((error) => reject(error?.response?.data?.detail));
	});
};

const handleDownloadSampleFile = (fileUrl: string): Promise<void> => {
	return new Promise((resolve, reject) => {
		axios
			.get(`${BASE_API_URL}${fileUrl}`, {
				headers: getAPIHeaderOptions(true),
				responseType: "blob"
			})
			.then((response) => {
				const responseContent = String(response.headers["content-disposition"]);
				const fileName = responseContent.split(DOWNLOAD_RESPONSE_CONTENT_FILENAME_IDENTIFIER)[1] ?? "";

				if (response.data) {
					downloadFile(new Blob([response.data]), fileName);
					resolve();
				} else {
					reject("Something went wrong");
				}
			})
			.catch((error) => reject(error?.response?.data?.detail));
	});
};

const handleDownloadAuthorizedList = (requestData: IGetAuthorizedListRequestData): Promise<void> => {
	return new Promise((resolve, reject) => {
		axios
			.get(`${BASE_API_URL}/analytics/download/members_info`, {
				headers: getAPIHeaderOptions(true),
				responseType: "blob",
				params: requestData
			})
			.then((response) => {
				if (response.data) {
					const responseContent = String(response.headers["content-disposition"]);
					const fileName = responseContent.split(DOWNLOAD_RESPONSE_CONTENT_FILENAME_IDENTIFIER)[1] ?? "";

					downloadFile(new Blob([response.data]), fileName);
					resolve();
				} else {
					reject("Something went wrong");
				}
			})
			.catch((error) => reject(error?.response?.data?.detail));
	});
};

const handleRunDiagnostics = (mailReport = false): Promise<{ fileName: string; fileBlob: Blob }> => {
	return new Promise((resolve, reject) => {
		axios
			.get(`${BASE_API_URL}/settings/diagnose`, {
				headers: getAPIHeaderOptions(true),
				params: { mail_report: mailReport },
				responseType: "blob"
			})
			.then((response) => {
				if (response.data) {
					const responseContent = String(response.headers["content-disposition"]);
					const fileName = responseContent.split(DOWNLOAD_RESPONSE_CONTENT_FILENAME_IDENTIFIER)[1] ?? "";

					resolve({ fileName: fileName, fileBlob: new Blob([response.data]) });
				} else reject("Something went wrong");
			})
			.catch((error) => reject(error?.response?.data?.detail));
	});
};

const downloadServices = {
	handleDownloadEventLogs,
	handleDownloadBlacklist,
	handleDownloadSampleFile,
	handleDownloadAuthorizedList,
	handleRunDiagnostics
};

export default downloadServices;
